import { trackInternalEvent } from '@rio/tracking'

import { useUser } from 'builder/hooks/useUser'
import { useI18n } from 'builder/hooks/useI18n'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { Candidate, Distribution } from 'builder/modules/resumeDistribution'
import useWebsiteHost from 'builder/components/CIO-Dasboard-2.0/hooks/useWebsiteHost'

import { CampaignBanner } from 'builder/views/ResumeDistributionDashboardView/components/DashboardBanner/CampaignBanner/CampaignBanner'
import { RecruitersInfo } from 'builder/views/ResumeDistributionDashboardView/components/DashboardBanner/RecruitersInfo/RecruitersInfo'
import { NextSchedule } from 'builder/views/ResumeDistributionDashboardView/components/DashboardBanner/NextSchedule/NextSchedule'

import { BannerSkeleton } from '../Skeleton/Skeleton'
import { TRANSLATION } from '../constants'
import * as Styles from './styles'

type HeaderProps = {
  candidate: Candidate
  nextDistributionDate?: Distribution
  distributedRecruiterCount: number
  isDistributionDatesLoading: boolean
}

export const Header = ({
  candidate,
  nextDistributionDate,
  distributedRecruiterCount,
  isDistributionDatesLoading,
}: HeaderProps) => {
  const user = useUser()
  const { i18n } = useI18n()
  const { getHost } = useWebsiteHost()

  const oneTimeRdSubscriptionType = candidate.localSubscriptionType === 'one_time'
  const key = oneTimeRdSubscriptionType ? 'upgrade_text_campaign' : 'upgrade_text'

  const upgradeNow = () => {
    trackInternalEvent('rd_click_upgrade', { website_host: getHost })
    goToBillingPlanPage({ upgradeURL: user?.billingInfo.upgradeUrl })
  }

  if (isDistributionDatesLoading) {
    return <BannerSkeleton />
  }

  return (
    <Styles.Container>
      {candidate?.localSubscriptionType === 'one_time' ? (
        <CampaignBanner count={distributedRecruiterCount} />
      ) : (
        <RecruitersInfo
          isFromWidget
          totalRecruiters={distributedRecruiterCount}
          distributionWeek={candidate?.distributionWeek || 0}
        />
      )}
      <Styles.Divider />
      {!user?.hasPremiumFeatures || candidate.localSubscriptionType === 'one_time' ? (
        <Styles.PremiumContainer>
          <Styles.PremiumTextContainer>
            {candidate.localSubscriptionType !== 'one_time' && <Styles.PremiumIcon />}
            <Styles.PremiumText>{i18n.t(`${TRANSLATION}.${key}`)}</Styles.PremiumText>
          </Styles.PremiumTextContainer>
          <Styles.PremiumContainerAction onClick={upgradeNow}>
            {i18n.t(`${TRANSLATION}.premium_button`)}
          </Styles.PremiumContainerAction>
        </Styles.PremiumContainer>
      ) : (
        <NextSchedule
          isFromWidget
          hideSchedule={!user?.hasPremiumFeatures}
          candidate={candidate}
          nextDistribution={nextDistributionDate}
          isLoading={false}
          action={() => {}}
        />
      )}
    </Styles.Container>
  )
}
